if (!customElements.get('revealed-media')) {
  class RevealedMedia extends HTMLElement {
    connectedCallback() {
      this.container = this.querySelector('.revealed-media--inner');
      this.image = this.querySelector('.revealed-media--media');
      this.content = this.querySelector('.revealed-media--content');
      if (!this.container || !this.image || typeof gsap === 'undefined' || this.dataset.motionEnabled !== 'true') return;
      this.media = gsap.matchMedia();
      this.media.add({
        desktop: '(min-width: 768px)',
        motion: '(prefers-reduced-motion: no-preference)'
      }, context => {
        if (!context.conditions.motion) return;
        const desktop = context.conditions.desktop;
        this.tl = gsap.timeline({
          scrollTrigger: {
            trigger: this.container,
            start: desktop ? 'center center' : 'top 85%',
            end: desktop ? '+=80%' : 'center center',
            pin: desktop,
            scrub: 0.5,
            invalidateOnRefresh: true,
            anticipatePin: desktop ? 1 : 0
          }
        });
        this.tl.fromTo(this.image, {
          clipPath: desktop ? 'inset(18% 28% 18%)' : 'inset(8% 8% 8%)'
        }, {
          clipPath: 'inset(0% 0% 0%)',
          ease: 'none',
          duration: 1
        });
        if (this.content) {
          this.tl.fromTo(this.content, {
            opacity: 0,
            filter: 'blur(6px)'
          }, {
            opacity: 1,
            filter: 'blur(0px)',
            ease: 'none',
            duration: 0.35
          }, 0.65);
        }
      });
    }
    disconnectedCallback() {
      if (this.media) this.media.revert();
    }
  }
  customElements.define('revealed-media', RevealedMedia);
}
